import OBase from './OBase';

import * as Geometry from '../geometry';

export default class VectorLength extends OBase {
  update () {
    let valTree = this.getVector3Input('Vector', false);
    let lOutput = this.getGenericObjectOutput('Length');

    var outTree = new Geometry.DataTree();

    for (let i = 0; i < valTree.branches.length; i++) {
      for (let j = 0; j < valTree.branches[i].length; j++) {
        let val = valTree.branches[i][j];
        let newval = val.length();
        outTree.add(newval, valTree.paths[i]);
      }
    }

    lOutput.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/VectorLength.js